import { render, staticRenderFns } from "./TableCellPointCount.vue?vue&type=template&id=d8159c1c&"
import script from "./TableCellPointCount.vue?vue&type=script&lang=ts&"
export * from "./TableCellPointCount.vue?vue&type=script&lang=ts&"
import style0 from "./TableCellPointCount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports